import axios from "axios";

export const getImageUrl = (path) => {
    return new URL(`/assets/${path}`, import.meta.url).href;
  };
  


  export const api = axios.create({
    baseURL: "https://api1.pepchat.in" 
  });
  
  api.interceptors.request.use(async (config) => {
    const token = localStorage.getItem("authToken"); // ✅ Use localStorage for token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // ✅ Bearer format
    }
    return config;
  }, (error) => {
    return Promise.reject(error);
  });
  

  

  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const status = error?.response?.status;

      if (status === 401 || status === 403) {
        // Check if we're on a public route that shouldn't redirect
        const publicRoutes = ['/post/', '/group/', '/uservibes/', '/vibe/', '/profile/', '/space/', '/'];
        const currentPath = window.location.pathname;
        const isPublicRoute = publicRoutes.some(route => currentPath.includes(route));

        if (!isPublicRoute && !error.config?.skipAuthRedirect) {
          // Clear all auth data for security
          localStorage.removeItem("authToken");
          localStorage.removeItem("isAdmin");

          // Redirect to login
          window.location.href = "/login";
        }
      }

      return Promise.reject(error);
    }
  );
